// Consume the `?unsubscribe=<email>&nlhash=<hash>` marketing-email link once on
// initial load: call the unsubscribe API and show its result via toast, then strip
// both params from the URL (leaving utm_*/nlaction/etc. intact).
//
// Runs on `app:mounted` rather than at plugin setup: this plugin is registered
// alphabetically before `services.ts` (which provides `$apiService`/useApi()), so
// calling useApi() directly at setup time would see it as undefined.
import { toast } from 'vue-sonner'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', async () => {
    const route = useRoute()
    const router = useRouter()

    const email = route.query.unsubscribe as string | undefined
    const nlhash = route.query.nlhash as string | undefined
    if (!email || !nlhash) return

    const api = useApi()
    const { $i18n } = useNuxtApp()

    try {
      const { data } = await api.unsubscribeNewsletter(email, nlhash)
      if (data.message_type === 'success' && data.message) {
        toast.success(data.message, { position: 'top-center' })
      } else if (data.message_type === 'error') {
        toast.error(data.message, { position: 'top-center' })
      } else if (data.message) {
        toast.warning(data.message, { position: 'top-center' })
      }
    } catch {
      toast.error($i18n.t('errors.server'), { position: 'top-center' })
    }

    const { unsubscribe, nlhash: _nlhash, ...rest } = route.query
    await router.replace({ path: route.path, query: rest, hash: route.hash })
  })
})
